import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { PixelPlaceholderLoader } from "@similarweb/ui-components";

import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const { carbon } = colorsPalettes;

export const DataRowContainer = styled(FlexRow)`
    justify-content: space-between;
    height: 33%;
    border-bottom: 1px solid ${carbon[50]};
    &:last-child {
        border-bottom: none;
    }
`;

export const DataRowTitle = styled(FlexRow)`
    align-items: center;
`;

export const DataTitle = styled.div`
    ${setFontVariant("subTitle3Alt", carbon[500])};
    text-wrap: nowrap;
`;

export const DataRowValue = styled(FlexRow)`
    align-items: center;
    .data-row-change-value {
        ${setFontVariant("input2")}
        > :first-child {
            margin-right: 4px;
        }
    }
`;

export const DataValue = styled.div`
    ${setFontVariant("h5", carbon[500])}
`;

export const DataDescription = styled.div`
    ${setFontVariant("caption", carbon[300])}
`;

const DataDescriptionLoader = styled(PixelPlaceholderLoader)`
    margin-top: 8px;
`;

export const ChangeContainer = styled(FlexRow)`
    gap: 4px;
    width: 130px;
    align-items: center;
    justify-content: flex-end;
`;

export const DataGrowthBasis = styled.div`
    ${setFontVariant("caption", carbon[300])}
    line-height: 16px;
`;
